import axios from "axios";
import { motion } from "framer-motion";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { WHATSAPP_LINK, openWhatsApp } from "@/lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const inputCls =
  "w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 text-base text-[#0B192C] placeholder:text-slate-400 outline-none transition-all duration-300 focus:border-amber-500 focus:ring-4 focus:ring-amber-400/20";

export const labelCls =
  "block text-xs font-bold uppercase tracking-[0.16em] text-slate-500 mb-2";

export async function submitLead(payload, message) {
  openWhatsApp(message);
  try {
    await axios.post(`${API}/leads`, payload);
    return true;
  } catch (e) {
    console.error("Falha ao registrar lead", e);
    return false;
  }
}

export const SuccessPanel = ({ title, text, whatsMsg, onReset }) => (
  <motion.div
    data-testid="lead-success-message"
    initial={{ opacity: 0, scale: 0.96 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="flex flex-col items-center justify-center rounded-3xl border border-emerald-200 bg-emerald-50/60 px-8 py-14 text-center"
  >
    <span className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100">
      <CheckCircle2 className="h-10 w-10 text-emerald-600" />
    </span>
    <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-[#0B192C]">{title}</h3>
    <p className="mt-3 max-w-md text-base leading-relaxed text-slate-600">{text}</p>
    <div className="mt-8 flex w-full flex-col items-center gap-3">
      <a
        data-testid="lead-whatsapp-fallback-link"
        href={`${WHATSAPP_LINK}?text=${encodeURIComponent(whatsMsg)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex w-full sm:w-auto items-center justify-center gap-2.5 rounded-full bg-[#25D366] px-8 py-4 text-base font-extrabold text-white shadow-[0_16px_40px_rgba(37,211,102,0.35)] transition-all duration-300 hover:bg-[#1fb857] hover:scale-[1.02]"
      >
        <MessageCircle className="h-5 w-5" />
        Concluir envio no WhatsApp
      </a>
      <p className="max-w-sm text-xs leading-relaxed text-slate-500 font-medium">
        O botão verde abre o seu WhatsApp com a mensagem pronta para a HB Solar — é só tocar em enviar.
      </p>
      <button
        data-testid="lead-new-request-button"
        onClick={onReset}
        className="mt-2 rounded-full border border-slate-300 px-6 py-3 text-sm font-bold text-slate-600 transition-colors duration-300 hover:border-amber-400 hover:text-[#0B192C]"
      >
        Enviar outra solicitação
      </button>
    </div>
  </motion.div>
);
